import { ModalV2 } from '@dapp/multi-lib/ui/V2Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Body2, Normal2 } from 'components/Typography';
import { Button } from '@dapp/multi-lib/sdaoui/Button';
import { twMerge } from 'tailwind-merge';
import moment from 'moment';
import { VaultTransaction } from '../../../../api/DynaVaultsAPI';

export const VaultDecisionReasoningModal = ({
  open,
  onOpenChange,
  decision,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  decision: VaultTransaction | null;
}) => {
  const { t } = useTranslation('vault');
  const dateString = moment(decision?.timestamp)
    .local()
    .format('DD MMM YYYY, hh:mm:ss A');
  if (!decision) return;

  return (
    <ModalV2.Root open={open} onOpenChange={onOpenChange}>
      <ModalV2.Content
        variant='dark'
        className='m-auto max-h-full w-[90%] max-w-[650px] overflow-y-auto rounded-none border-[0.5px] border-tab-color bg-[#000000] text-white md:w-full md:!min-w-[550px]'
      >
        <ModalV2.BodyTitle
          variant='dark'
          endEnhancer={<ModalV2.Close variant='dark' />}
        >
          <Normal2 className='text-normal text-xs md:text-lg'>
            {t('AGENT_DECISION_ON') + ' ' + dateString}
          </Normal2>
        </ModalV2.BodyTitle>
        <div
          className='mb-3 flex items-start gap-3 border-b border-dashed border-black-300 pb-4'
          style={{
            borderImage:
              'repeating-linear-gradient(45deg, #b5b5b5 0px, #b5b5b5 10px, transparent 10px, transparent 20px) 1',
          }}
        ></div>
        <ModalV2.Body variant='dark' className='mx-0 my-0'>
          {decision ? (
            <div className='flex flex-col gap-6'>
              <ModalRowData
                title={t('VAULT_DECISION_REASONING_TABLE.ACTION')}
                subtitle={decision.reasoning?.action}
              />
              <ModalRowData
                title={t('VAULT_DECISION_REASONING_TABLE.TOKEN')}
                subtitle={decision.reasoning?.token}
              />
              <ModalRowData
                title={t('VAULT_DECISION_REASONING_TABLE.REASONING')}
                subtitle={decision.reasoning?.reasoning}
              />
            </div>
          ) : (
            <Body2>No data available</Body2>
          )}
          <Button
            onClick={() => onOpenChange(false)}
            style={'ghost'}
            className={twMerge(
              'rounded-main mx-auto mt-6 flex w-full max-w-max flex-row gap-1 border-[0.5px] border-grey-100 bg-black px-10 py-2 hover:bg-[linear-gradient(103deg,_#363636_0%,_#1A1A1A_100%)]'
            )}
          >
            {t('VAULT_REPORTING_TABLE.CANCLE')}
          </Button>
        </ModalV2.Body>
      </ModalV2.Content>
    </ModalV2.Root>
  );
};

export const ModalRowData = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => {
  return (
    <div className='flex items-start gap-4'>
      <Body2 className='font-haben font-bold text-black-300'>{title}:</Body2>
      <Body2>{subtitle || '-'}</Body2>
    </div>
  );
};
